import { apply, put, select, all } from 'redux-saga/effects';
import { errorNotification, successNotification } from '../reducers/notification.reducers';
import {
  loadMenuTreeAction, loadProductsAction, loadProductionPlacesAction,
} from '../reducers/menu.reducers';

const getDataObject = (data) => {
  const newData = { ...data };

  // if (data.orderableHours) {
  //   newData.orderable = true;
  // }
  // if (data.visibleHours) {
  //   newData.visible = true;
  // }

  return newData;
};

export function* loadMenuTree(menuApi, { payload }) {
  try {
    const response = yield apply(
      menuApi,
      menuApi.loadMenuTree,
      [payload],
    );
    if (response.errorCode) {
      yield put(errorNotification('Menüs konnten nicht geladen werden!'));
      yield put(loadMenuTreeAction.FAILED());
    } else {
      const menus = response.data.menus.filter(m => m.name != 'Hidden menu');
      yield put(loadMenuTreeAction.DONE(menus));
    }
  } catch (e) {
    yield put(errorNotification('Menüs konnten nicht geladen werden!'));
    yield put(loadMenuTreeAction.FAILED());
  }
}

export function* updateMenu(menuApi, { payload }) {
  try {
    const response = yield apply(menuApi, menuApi.updateMenu, [payload]);
    if (response.errorCode) {
      yield put(errorNotification('Menü konnte nicht aktualisiert werden!'));
    } else {
      yield put(successNotification('Menü erfolgreich aktualisiert!'));
    }
  } catch (error) {
    yield put(errorNotification('Menü konnte nicht aktualisiert werden!'));
  }
}

export function* updateMenus(menuApi, { payload }) {
  try {
    const data = getDataObject(payload.data);

    const response = yield all(payload.menuIds.map(menuId => apply(menuApi, menuApi.updateMenu.bind(menuApi, { menuId, data }))));
    if (response.errorCode) {
      yield put(errorNotification('Menüs konnten nicht aktualisiert werden!'));
    } else {
      yield put(successNotification('Menüs erfolgreich aktualisiert!'));
    }
  } catch (error) {
    yield put(errorNotification('Menüs konnten nicht aktualisiert werden!'));
  }
}

export function* updateCategory(menuApi, { payload }) {
  try {
    const response = yield apply(menuApi, menuApi.updateCategory, [payload]);
    if (response.errorCode) {
      yield put(errorNotification('Kategorie konnte nicht aktualisiert werden!'));
    } else {
      yield put(successNotification('Kategorie erfolgreich aktualisiert!'));
    }
  } catch (error) {
    yield put(errorNotification('Kategorie konnte nicht aktualisiert werden!'));
  }
}

export function* updateCategories(menuApi, { payload }) {
  try {
    const data = getDataObject(payload.data);
    const response = yield all(payload.categoryIds.map(categoryId => apply(menuApi, menuApi.updateCategory.bind(menuApi, { categoryId, data }))));
    if (response.errorCode) {
      yield put(errorNotification('Kategorien konnten nicht aktualisiert werden!'));
    } else {
      yield put(successNotification('Kategorien erfolgreich aktualisiert!'));
    }
  } catch (error) {
    yield put(errorNotification('Kategorien konnten nicht aktualisiert werden!'));
  }
}

export function* updateMenuEntry(menuApi, { payload }) {
  try {
    const response = yield apply(menuApi, menuApi.updateMenuEntry, [payload]);
    if (response.errorCode) {
      yield put(errorNotification('Menüeintrag konnte nicht aktualisiert werden!'));
    } else {
      yield put(successNotification('Menüeintrag erfolgreich aktualisiert!'));
    }
  } catch (error) {
    yield put(errorNotification('Menüeintrag konnte nicht aktualisiert werden!'));
  }
}

export function* updateMenuEntries(menuApi, { payload }) {
  try {
    const data = getDataObject(payload.data);
    const response = yield all(payload.menuEntryIds.map(menuEntryId => apply(menuApi, menuApi.updateMenuEntry.bind(menuApi, { menuEntryId, data }))));
    if (response.errorCode) {
      yield put(errorNotification('Menüeinträge konnten nicht aktualisiert werden!'));
    } else {
      yield put(successNotification('Menüeinträge erfolgreich aktualisiert!'));
    }
  } catch (error) {
    yield put(errorNotification('Menüeinträge konnten nicht aktualisiert werden!'));
  }
}

export function* loadProducts(menuApi, { payload }) {
  try {
    const response = yield apply(menuApi, menuApi.loadProducts, [payload]);
    if (response.errorCode) {
      yield put(errorNotification('Produkte konnten nicht geladen werden!'));
      yield put(loadProductsAction.FAILED());
    } else {
      yield put(loadProductsAction.DONE(response));
    }
  } catch (error) {
    yield put(errorNotification('Produkte konnten nicht geladen werden!'));
    yield put(loadProductsAction.FAILED());
  }
}

export function* updateProduct(menuApi, { payload }) {
  try {
    const response = yield apply(menuApi, menuApi.updateProduct, [payload]);
    if (response.errorCode) {
      yield put(errorNotification('Produkt konnte nicht aktualisiert werden!'));
    } else {
      yield put(successNotification('Produkt erfolgreich aktualisiert!'));
    }
  } catch (error) {
    yield put(errorNotification('Produkt konnte nicht aktualisiert werden!'));
  }
}

export function* updateProducts(menuApi, { payload }) {
  try {
    const data = getDataObject(payload.data);

    const response = yield all(payload.productIds.map(productId => apply(menuApi, menuApi.updateProduct.bind(menuApi, { productId, data }))));
    if (response.errorCode) {
      yield put(errorNotification('Produkte konnten nicht aktualisiert werden!'));
    } else {
      yield put(successNotification('Produkte erfolgreich aktualisiert!'));
    }
  } catch (error) {
    yield put(errorNotification('Produkte konnten nicht aktualisiert werden!'));
  }
}

export function* loadProductionPlaces(menuApi) {
  try {
    const user = yield select(state => state.authentication.user);
    const locationId = user.staffLocationID;
    const response = yield apply(menuApi, menuApi.loadProductionPlaces, [locationId]);

    if (response.errorCode) {
      yield put(errorNotification('Produktionsplätze konnten nicht geladen werden!'));
      yield put(loadProductionPlacesAction.FAILED());
    } else {
      yield put(loadProductionPlacesAction.DONE(response.data.filter(x => !!x.locationId)));
    }
  } catch (error) {
    yield put(errorNotification('Produktionsplätze konnten nicht geladen werden!'));
  }
}
